import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { fetchPersonalDetails } from 'lib/actions';
import {
    getPersonalDetails,
    getPersonalDetailsIsFetching,
} from 'lib/selectors';
import { useEditPersonalDetails } from 'lib/hooks';
import { MORE_PERSONAL_DETAILS } from 'constants/shared/routes';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import { dispatchShowModal } from 'utils/modals';
import { SUCCESS_MODAL } from 'constants/shared/modalTypes';
import useTranslate from 'lib/languages/useTranslate';
import { IPersonalDetails, PersonalDetailSection } from 'lib/type';
import EditAddressDetails from '../presentational/EditAddressDetails';
import EditContactDetails from '../presentational/EditContactDetails';

const EditPersonalDetailsContainer = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const details = useSelector(getPersonalDetails) as IPersonalDetails;
    const isFetching = useSelector(getPersonalDetailsIsFetching) as boolean;
    const translate = useTranslate('personalDetails');

    const { editPart } = location.state || {};

    const {
        formData,
        onChange,
        onSubmit,
        isPosting,
        error,
        handleSwitchClick,
        resetData,
    } = useEditPersonalDetails(handleSubmit);

    function handleSubmit() {
        dispatchShowModal(dispatch, SUCCESS_MODAL, {
            message: 'Personal Details Updated',
        });
        history.push(MORE_PERSONAL_DETAILS);
    }

    const renderEditPart = () => {
        const commonProps = {
            data: details,
            ...formData,
            handleChange: onChange,
            handleSubmit: onSubmit,
            isPosting,
            error,
            handleSwitchClick,
            resetData,
        };

        const Component =
            editPart === PersonalDetailSection.ADDRESS ? EditAddressDetails : EditContactDetails;


        return <Component {...commonProps} />;
    };

    useEffect(() => {
        dispatch(fetchPersonalDetails());
    }, [dispatch]);

    return (
        <PageContainer className="more-edit-personal-details-container">
            <SectionTitle
                title={translate('form.editPersonalDetails')}
                backRoute={MORE_PERSONAL_DETAILS}
            />
            <DataCheck
                data={details}
                isLoading={isFetching}
                noDataMessage={translate('noDataMessage')}
            >
                {renderEditPart()}
            </DataCheck>
        </PageContainer>
    );
};

export default EditPersonalDetailsContainer;
